import { Component, Input, OnChanges } from '@angular/core';
import { VoltageSpeedDashboardSample, VoltageSpeedVoltageChange } from '../../voltage-with-speed.models';
import { VoltageSpeedDailyEvent } from './daily-events.models';
import { buildDailyEvents } from './daily-events.utils';

@Component({
  selector: 'app-voltage-speed-daily-events',
  templateUrl: './daily-events.component.html'
})
export class VoltageSpeedDailyEventsComponent implements OnChanges {
  @Input() samples: VoltageSpeedDashboardSample[] = [];
  @Input() changes: VoltageSpeedVoltageChange[] = [];

  rows: VoltageSpeedDailyEvent[] = [];
  visibleRows: VoltageSpeedDailyEvent[] = [];
  page = 1;
  pageSize = 10;

  ngOnChanges(): void {
    this.rows = buildDailyEvents(this.samples, this.changes);
    this.setPage(1);
  }

  setPage(page: number): void {
    this.page = page;
    this.visibleRows = this.rows.slice((page - 1) * this.pageSize, page * this.pageSize);
  }

  setPageSize(size: number): void {
    this.pageSize = size;
    this.setPage(1);
  }
}
